// @ts-nocheck

import { MyMatchAPIErrorIds } from '../constants/mymatch';
import { BetTemplates } from '../types/bet';
import { MatchViewModes } from '../types/matchView';
import { OutcomeModes } from '../types/outcome';

import NumberUtils from './number';

/*
 * Exception for the 'ListOdd' bet template, minimum odd value is 1 included
 * https://redmine.winamax.fr/issues/95648
 */
const getMode = ({
  oddsId,
  matchIsAvailable,
  betIsAvailable,
  betTemplate,
  oddValue,
  outcomeIsAvailable,
  isForbidden = false,
  matchViewMode = MatchViewModes.CLASSIC,
  mmOdds,
  multichoiceMMOdds,
  matchcachedMMAPIResponsesInfos,
  mmContradicting,
  multichoiceMMContradicting,
  isFromMultichoice,
  nbBasketMatchSelections,
  isSelected,
}) => {
  if (matchViewMode === MatchViewModes.CLASSIC) {
    if (outcomeIsAvailable) {
      if (oddValue > 1) {
        if (isForbidden) {
          return OutcomeModes.PAUSE;
        } else {
          return !!matchIsAvailable && !!betIsAvailable ? OutcomeModes.PLAY : OutcomeModes.PAUSE;
        }
      } else if (betTemplate === BetTemplates.LIST_ODD && oddValue === 1) {
        return OutcomeModes.STOP_BUT_DISPLAYED;
      }
    }

    return OutcomeModes.STOP;
  }

  if (matchViewMode === MatchViewModes.MY_MATCH) {
    if (outcomeIsAvailable) {
      const { errorId, selections } = matchcachedMMAPIResponsesInfos.result?.mymatchError ?? {};

      const hasMMError = (() => {
        if (selections) {
          return (
            errorId === MyMatchAPIErrorIds.SELECTION_INACTIVE ||
            !!selections.find(({ outcomeId }) => outcomeId === oddsId)
          );
        }

        return (
          !!errorId || (!isFromMultichoice && mmContradicting) || (isFromMultichoice && multichoiceMMContradicting)
        );
      })();

      if (hasMMError) {
        if (errorId !== MyMatchAPIErrorIds.SELECTION_INACTIVE || !isSelected) {
          return OutcomeModes.MY_MATCH_ANY_ERROR;
        }
      }

      const isOddsValueValid = (() => {
        if (!nbBasketMatchSelections) {
          return oddValue > 1;
        }

        return isFromMultichoice
          ? multichoiceMMOdds === undefined || multichoiceMMOdds > 1
          : mmOdds === undefined || mmOdds > 1;
      })();

      if (isOddsValueValid || isSelected) {
        if (isForbidden || !betIsAvailable) {
          if (isSelected) {
            return OutcomeModes.MY_MATCH_ANY_ERROR;
          }

          return OutcomeModes.PAUSE;
        } else {
          return matchIsAvailable ? OutcomeModes.PLAY : OutcomeModes.MY_MATCH_ANY_ERROR;
        }
      } else {
        return OutcomeModes.MY_MATCH_ANY_ERROR;
      }
    }

    return OutcomeModes.MY_MATCH_ANY_ERROR;
  }

  return OutcomeModes.STOP;
};

export const getScoresColumns = (betType) => (outcomes) => {
  const finalOutcomes = outcomes.reduce(
    (acc, odd) => {
      // key look like that --> 3:1
      const x = odd?.code?.split(':')?.map((n) => NumberUtils.castNumber(n)) ?? [];
      if (x.length === 1) {
        // https://redmine.winamax.fr/issues/73190
        if (/competitor two/i.test(odd.code)) {
          return {
            ...acc,
            right: [...acc.right, odd],
          };
        }
        if (odd.code === 'other') {
          return {
            ...acc,
            center: [...acc.center, odd],
          };
        }
        // https://redmine.winamax.fr/issues/77166
        const column = [220, 57, 21, 1678, 1487, 1472].indexOf(betType) !== -1 ? 'center' : 'left';
        return {
          ...acc,
          [`${column}`]: [...acc[column], odd],
        };
      } else if (x[0] > x[1]) {
        return {
          ...acc,
          left: [...acc.left, odd],
        };
      } else if (x[0] < x[1]) {
        return {
          ...acc,
          right: [...acc.right, odd],
        };
      } else if (x[0] === x[1]) {
        return {
          ...acc,
          center: [...acc.center, odd],
        };
      }
      return acc;
    },
    { left: [], right: [], center: [] },
  );
  finalOutcomes.left.sort((a, b) => {
    const x = a?.code?.split(':')?.map((n) => NumberUtils.castNumber(n)) ?? [];
    const y = b?.code?.split(':')?.map((n) => NumberUtils.castNumber(n)) ?? [];
    if (x.length === 1) {
      return 1;
    } else if (x[0] < y[0]) {
      return -1;
    } else if (x[0] > y[0]) {
      return 1;
    } else if (x[1] > y[1]) {
      return 1;
    }
    return -1;
  });
  finalOutcomes.center.sort((a, b) => {
    const x = a?.code?.split(':')?.map((n) => NumberUtils.castNumber(n)) ?? [];
    const y = b?.code?.split(':')?.map((n) => NumberUtils.castNumber(n)) ?? [];
    if (x.length === 1 || x[0] > y[0]) {
      return 1;
    }
    return -1;
  });
  finalOutcomes.right.sort((a, b) => {
    const x = a?.code?.split(':')?.map((n) => NumberUtils.castNumber(n)) ?? [];
    const y = b?.code?.split(':')?.map((n) => NumberUtils.castNumber(n)) ?? [];
    if (x.length === 1) {
      return 1;
    } else if (x[1] > y[1]) {
      return 1;
    } else if (x[1] < y[1]) {
      return -1;
    } else if (x[0] > y[0]) {
      return 1;
    }
    return -1;
  });
  return finalOutcomes;
};

export default {
  getMode,
  getScoresColumns,
};
